import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  current: number;
  total: number;
  colorClass?: string;
}
export function ProgressBar({
  current,
  total,
  colorClass = 'bg-emerald-500'
}: ProgressBarProps) {
  const percentage = total > 0 ? current / total * 100 : 0;
  return <div className="w-full" data-id="element-358" data-mp="dxi7v2z5ydlr">
      <div className="flex items-center justify-between mb-1.5" data-id="element-359" data-mp="dya50i8esje5">
        <span className="text-xs font-medium text-slate-400" data-id="element-360" data-mp="1an9bpstchd48">
          {current} of {total} complete
        </span>
        <span className="text-xs font-semibold text-slate-300" data-id="element-361" data-mp="16mpg4tof6hk7">
          {Math.round(percentage)}%
        </span>
      </div>
      <div className="w-full h-2 bg-slate-700/60 rounded-full overflow-hidden" data-id="element-362" data-mp="11kgmdv3q3bh1">
        <motion.div className={`h-full rounded-full ${colorClass}`} initial={{
        width: 0
      }} animate={{
        width: `${percentage}%`
      }} transition={{
        duration: 0.5,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} data-id="element-363" data-mp="wmf43ce4fg6m" />
      </div>
    </div>;
}